import * as React from 'react';
import * as _ from 'lodash';
import {
  Logging,
} from '@vcd-ecm-ui/Common';
import {
  TagColors,
  VtxInput,
  VtxSwitch,
  VtxTag,
} from '@vertexinc/vtx-ui-react-component-library';
import FieldProps from './FieldProps.interface';
import '../common-settings.scss';

const Field = ({
  index,
  active,
  disabled,
  onChangeActive,
  label,
  originalValue,
  value,
  onChangeValue,
  illegalCharacters = null,
}: FieldProps): JSX.Element => {
  Logging.Debug('Field', index, active, label, originalValue, value);

  const tagColor: TagColors = active ? 'blue' : 'default';

  const removeIllegalCharacters = (inputValue: string): string => {
    if (illegalCharacters && inputValue) {
      let filteredValue = inputValue;

      // eslint-disable-next-line arrow-body-style
      illegalCharacters.forEach((character: string) => {
        filteredValue = filteredValue.replace(character, '');
      });

      return filteredValue;
    }

    return inputValue;
  };

  return (
    <div className={`customField ${active ? 'customFieldEnabled' : 'customFieldDisabled'}`}>
      <div className="customFieldIndex">
        <VtxTag
          key={`field-tag-${index}`}
          color={tagColor}
        >
          {index}
        </VtxTag>
      </div>
      <div className="customFieldActive">
        <VtxSwitch
          key={`field-switch-${index}`}
          checkedChildren="On"
          disabled={disabled}
          defaultChecked
          unCheckedChildren="Off"
          checked={active}
          onChange={(checked) => onChangeActive(index, checked)}
        />
      </div>
      <div className="customFieldLabel">
        {`${active ? label : '--'}`}
      </div>
      {
        active
        && (
          <>
            <div className="customFieldValue">
              <VtxInput
                key={`field-input-${index}`}
                type="text"
                disabled={disabled}
                id={index.toString()}
                value={value || ''}
                placeholder={originalValue}
                onChange={(event) => onChangeValue(index, removeIllegalCharacters(event.target.value))}
              />
            </div>
            {
              value
                ? (
                  <div className="customFieldOriginalValue">
                    as {originalValue}
                  </div>
                )
                : (
                  <div className="customFieldRequiredValue">
                    This is a required field
                  </div>
                )
            }
          </>
        )
      }
    </div>
  );
};

export default Field;
